import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import cx from 'classnames';
import { noop } from 'lodash';
import "./Dialog.css";

var ModalDialog = function ModalDialog(_a) {
  var className = _a.className,
      overlayClassName = _a.overlayClassName,
      shouldCloseOnOverlayClick = _a.shouldCloseOnOverlayClick,
      shouldReturnFocusAfterClose = _a.shouldReturnFocusAfterClose,
      onClose = _a.onClose,
      children = _a.children,
      portalClassName = _a.portalClassName,
      modalRef = _a.modalRef;
  return React.createElement(Modal, {
    ariaHideApp: false,
    portalClassName: cx('ReactModalPortal', portalClassName),
    className: cx('nx-modals-dialog', className),
    overlayClassName: cx('nx-modals-overlay', overlayClassName),
    contentLabel: "",
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    shouldReturnFocusAfterClose: shouldReturnFocusAfterClose,
    isOpen: true,
    onRequestClose: onClose,
    ref: modalRef,
    role: "dialog"
  }, children);
};

ModalDialog.propTypes = {
  className: PropTypes.string,
  overlayClassName: PropTypes.string,
  portalClassName: PropTypes.string,
  children: PropTypes.node,
  modalRef: PropTypes.func,
  onClose: PropTypes.func,
  shouldCloseOnOverlayClick: PropTypes.bool,
  shouldReturnFocusAfterClose: PropTypes.bool
};
ModalDialog.defaultProps = {
  shouldCloseOnOverlayClick: false,
  shouldReturnFocusAfterClose: true,
  onClose: noop
};
export default ModalDialog;

try {
  // @ts-ignore
  Dialog.__docgenInfo = {
    "description": "",
    "displayName": "Dialog",
    "props": {
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "portalClassName": {
        "defaultValue": null,
        "description": "",
        "name": "portalClassName",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "overlayClassName": {
        "defaultValue": null,
        "description": "",
        "name": "overlayClassName",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "shouldCloseOnOverlayClick": {
        "defaultValue": null,
        "description": "",
        "name": "shouldCloseOnOverlayClick",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "shouldReturnFocusAfterClose": {
        "defaultValue": null,
        "description": "",
        "name": "shouldReturnFocusAfterClose",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "modalRef": {
        "defaultValue": null,
        "description": "",
        "name": "modalRef",
        "required": false,
        "type": {
          "name": "string | ((instance: ReactModal | null) => any) | RefObject<ReactModal> | undefined"
        }
      },
      "onClose": {
        "defaultValue": null,
        "description": "",
        "name": "onClose",
        "required": false,
        "type": {
          "name": "((event: KeyboardEvent | MouseEvent) => void) | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}